"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LocalStorageMap {
    constructor(id) {
        this.id = id;
    }
    load() {
        const json = window.localStorage.getItem(this.id);
        this.state = (json && JSON.parse(json)) ?? {};
    }
    save() {
        try {
            window.localStorage.setItem(this.id, JSON.stringify(this.state));
        }
        catch (e) {
            throw new Error("Localstorage is full: " + this.localStorageSpace() + "is used. error:" + e);
        }
    }
    setValue(key, value) {
        if (value !== undefined && value !== null) {
            this.state[key] = value;
        }
        else {
            delete this.state[key];
        }
    }
    getValue(key) {
        return this.state[key];
    }
    localStorageSpace() {
        const items = { ...window.localStorage };
        const allStrings = Object.values(items).join("");
        return allStrings ? 3 + ((allStrings.length * 16) / (8 * 1024)) + " KB" : "Empty (0 KB)";
    }
    ;
}
exports.default = LocalStorageMap;
//# sourceMappingURL=LocalStorageMap.js.map